<script lang="ts">
  import DateElement from '$src/js/modules/events/DateElement.svelte';
  import Svg from '$src/js/modules/ui/components/Svg.svelte';
  import type { R2REvent } from '$src/types/events';

  const {
    event,
    mode = 'detail',
  }: {
    event: R2REvent;
    mode: 'detail' | 'edit';
  } = $props();

  let clickoutUrl = $state<string>(event.slug);

  if (mode === 'edit') {
    clickoutUrl = event.editableSlug ?? '#';
  }

  const getSvgLogo = () => {
    if (
      event.type.slug === 'dikke-banden-race' ||
      event.type.slug === 'rabo-dikke-banden-race'
    ) {
      return 'logo-rabo-dbr';
    }

    return 'logo-r2r-plain-wrap';
  };
</script>

<a
  href={clickoutUrl}
  class="border-b-white-150 group flex w-full flex-row gap-4 border-b-1 py-8 first:pt-0 md:gap-8"
>
  <div>
    <DateElement date={event.date.date} theme={event.type.color} />
  </div>

  <div class="flex flex-1 flex-col gap-4 md:gap-5">
    <h3
      class="2xl:fluid-text-[22] font-roc text-[1.25rem] leading-[120%] font-bold normal-case group-hover:underline lg:text-[1.375rem]"
    >
      {event.title}
    </h3>

    <div class="flex flex-row flex-wrap content-start items-center gap-4">
      <div
        class="text-12px 2xl:fluid-h-[28] border-white-1000 flex h-7 flex-row items-center border-1 leading-[1.2]"
      >
        <div
          class="bg-white-1000 2xl:fluid-w-[24] flex h-full w-6 items-center justify-center"
        >
          <Svg
            image={getSvgLogo()}
            width={24}
            height={24}
            className="2xl:fluid-w-[24] 2xl:fluid-h-[24] fill-black-1000"
          />
        </div>

        <span class="px-2 font-medium">{event.type.title}</span>
      </div>

      <div class="flex items-center gap-1">
        <Svg
          image="location"
          width={20}
          height={20}
          className="2xl:fluid-w-[20] 2xl:fluid-h-[20] fill-white-1000"
        />
        <span class="text-14px leading-[120%]">{event.location.name}</span>
      </div>
    </div>
  </div>
  <Svg
    image="chevron-right"
    width={24}
    height={24}
    className="2xl:fluid-w-[24] 2xl:fluid-h-[24] fill-white-1000 transition-all group-hover:fill-primary"
  />
</a>
